import {
  BrandName,
  SupportedCountryCode
} from '@seek/je-shared-data/lib/types/brand';

// The jobs.adDuration BFF procedure was decommissioned along with je-client /
// je-job-service. This hook is retained as an inert stub so obsolete job UI
// still compiles; ad duration is no longer fetched from a backend.
export type QueryOptions = {
  enabled?: boolean;
};

type Params = {
  countryCode: SupportedCountryCode;
  brand: BrandName;
};

export type ErrorResponse = null;

export const useFetchAdDuration = (
  _params: Params,
  _queryOptions?: QueryOptions
) => {
  return {
    data: undefined as any,
    isError: false,
    error: null as ErrorResponse,
    isLoading: false
  };
};
